import { DownloadResponse } from './model/download-reponse.interface';
import { DownloadMoment } from './model/download-moment.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RemoteApiService } from '../core';
import { DownloadRequest } from './model/download-request.interface';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  constructor(private remoteApi: RemoteApiService, private http: HttpClient) {}

  getDownloads(email: string): Observable<DownloadResponse[]> {
    const parameters: any = {};
    return this.remoteApi
      .getDownload<DownloadResponse[]>(`/download/${email}`, parameters)
      .pipe(
        map((resp: DownloadResponse[]) => {
          return resp;
        })
      );
  }

  downloadFile(url: string): Observable<any> {
    return this.http.get(url, { responseType: 'blob' });
  }

  postDownload(body: DownloadRequest): Observable<any> {
    return this.remoteApi.postDownload('/download', body).pipe(map((resp: any) => resp));
  }
}
